export default "__VITE_ASSET__995dfe6a__"